import { UPDATE_STORE_ID, VALIDATE_TOKEN } from '../action-types'

const initialState = {}
const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case VALIDATE_TOKEN:
      return { ...state, ...payload }
    case UPDATE_STORE_ID:
      return { ...state, storeId: payload }
    default:
      return state
  }
}
export default userReducer